import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ApplyLeaveApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-leave'
    }




    /**
     * 获取请假时长
     * @param startTime 
     * @param endTime 
     * @returns 
     */
    public getLeaveHours(startTime, endTime) {
        return this.send({ startTime: startTime, endTime: endTime}, "getLeaveHours", this.Methods.GET)
    }



}